import { AuthService } from "src/app/core/services/auth.service";
import { Scope } from "../enum/scope.enum";

export class NavigationEntry {
    title: string;
    url: string;
    icon: string;
    extraclass: string;
    isSeparator: boolean;
    isGrow: boolean;
    scope: Scope[];
    cbFunction:  Function;
    constructor({ title = '', url = '', icon = '', isSeparator = false, isGrow = false, scope = [Scope.Default], extraclass = '', cbFunction = () => {} }) {
        this.title = title;
        this.url = url;
        this.icon = icon;
        this.extraclass = extraclass;
        this.isSeparator = isSeparator;
        this.isGrow = isGrow;
        this.scope = scope;
        this.cbFunction = cbFunction;
    }
}
